import { render } from "./index2.vue?vue&type=template&id=cc4c48bc"
import script from "./index2.vue?vue&type=script&lang=ts"
export * from "./index2.vue?vue&type=script&lang=ts"

import "./index2.vue?vue&type=style&index=0&id=cc4c48bc&lang=less"
script.render = render

export default script